module.exports={name:"把回忆拼好给你",artists:"王贰浪",picUrl:"http://p1.music.126.net/CBx2K_jEN3SNWwYztagPPw==/109951164485969446.jpg"};